/**
 * NOS-91: Add element catalog inside SectionContextPanel.
 * Per docs/specs/BUILDER_DESIGN_SPEC.md Section 9.
 */
import { useState } from "react"
import {
  COMPONENT_CATALOG,
  COMPONENT_CATEGORIES,
  getDefaultElementContent,
  type ComponentCategory,
} from "./componentCatalog"

export interface AddElementCatalogProps {
  primaryColor: string
  onSelect: (type: string, defaultContent: Record<string, unknown>) => void
  onCancel: () => void
}

export function AddElementCatalog({ primaryColor, onSelect, onCancel }: AddElementCatalogProps) {
  const [category, setCategory] = useState<ComponentCategory>("All")

  const filtered =
    category === "All"
      ? COMPONENT_CATALOG
      : COMPONENT_CATALOG.filter((c) => c.category === category)

  return (
    <div
      style={{
        background: "rgba(255,255,255,0.03)",
        borderRadius: 10,
        border: "1px solid rgba(255,255,255,0.06)",
      }}
    >
      {/* Category tabs - Section 9 */}
      <div
        style={{
          borderBottom: "1px solid rgba(255,255,255,0.05)",
          padding: "0 4px",
          display: "flex",
          gap: 0,
          overflowX: "auto",
        }}
      >
        {COMPONENT_CATEGORIES.map((cat) => (
          <button
            key={cat}
            type="button"
            onClick={() => setCategory(cat)}
            style={{
              padding: "8px 10px",
              font: "inherit",
              fontSize: 10,
              fontWeight: 600,
              whiteSpace: "nowrap",
              cursor: "pointer",
              border: "none",
              background: "transparent",
              color: category === cat ? "#fff" : "rgba(255,255,255,0.35)",
              borderBottom: `2px solid ${category === cat ? primaryColor : "transparent"}`,
            }}
          >
            {cat}
          </button>
        ))}
      </div>
      {/* Component grid - Section 9 */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 4,
          padding: 8,
          maxHeight: 200,
          overflowY: "auto",
        }}
      >
        {filtered.map((item) => (
          <button
            key={item.type}
            type="button"
            onClick={() => {
              const content = getDefaultElementContent(item.type)
              onSelect(item.type, content)
            }}
            style={{
              padding: "10px 4px",
              background: "rgba(255,255,255,0.02)",
              border: "1px solid rgba(255,255,255,0.04)",
              borderRadius: 6,
              color: "rgba(255,255,255,0.6)",
              fontSize: 10,
              fontWeight: 500,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 4,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            <span style={{ fontSize: 16 }}>{item.icon}</span>
            <span>{item.label}</span>
          </button>
        ))}
      </div>
      {/* Cancel button - Section 9 */}
      <div style={{ padding: "4px 8px 8px" }}>
        <button
          type="button"
          onClick={onCancel}
          style={{
            width: "100%",
            padding: 6,
            background: "transparent",
            border: "1px solid rgba(255,255,255,0.06)",
            borderRadius: 6,
            color: "rgba(255,255,255,0.35)",
            fontSize: 10,
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  )
}
